
<div>

<aside class="main-sidebar elevation-4 sidebar-dark-info" style="min-height: 313px;">
  <a href="javascrpit:void(0)" routerLink="/" class="brand-link bg-info">
    <img src="assets/images/hayti_logo.png" alt="Logo" class="brand-image" style="float:unset;">
  </a>

  <div class="sidebar">
    <!-- <div class="user-panel mt-3 pb-3 mb-3 d-flex">
      <div class="image">
        <img src="" class="img-circle elevation-2" alt="User Image">
      </div>
      <div class="info
      ">
        <a href="#" routerLink="/users/profile" class="d-block"></a>
      </div>
    </div> -->

    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column">
        <li class="nav-item" *ngIf="userRole == 1">
          <a class="nav-link" routerLink="/admin/dashboard">
            <i class="nav-icon fa fa-dashboard"></i>
            <p>Dashboard</p>
          </a>
        </li>
        <li class="nav-item dropdown dropdown-custom" id="reports">
          <a class="nav-link" href="javascript:void(0)" >
            <i class="nav-icon fa fa-bar-chart"></i>
            <p>Reports</p>
          </a>
          <button class="btn btn-secondary dropdown-toggle" id="side-dropdown" type="button">
          </button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLink="/admin/top-10">Top 10 of the Day</a></li>
            <li><a class="dropdown-item" routerLink="/admin/article-report">Article Stats</a></li>
            <li><a class="dropdown-item" routerLink="/admin/publisher-report">Zero Report</a></li>
            <li><a class="dropdown-item" routerLink="/admin/popular-podcast">Popular Podcasts</a></li>
            <li><a class="dropdown-item" routerLink="/admin/category-podcast">Category Podcasts</a></li>
            <!-- <li><a class="dropdown-item" routerLink="/admin/comment">Comments</a></li> -->
          </ul>
        </li>
        <li class="nav-item">
          <!-- <a class="" (click)="userlist()"></a> -->
          <a class="nav-link" routerLink="/admin/content">
          <!-- <a href="javascript:void(0)"  class="nav-link"> -->
            <i class=" nav-icon fa fa-file" aria-hidden="true"></i>
            <p>Content</p>
          </a>
        </li>
        <li class="nav-item">
          <!-- <a class="" (click)="userlist()"></a> -->
          <a class="nav-link" routerLink="/admin/article-press-media">
          <!-- <a href="javascript:void(0)"  class="nav-link"> -->
            <i class=" nav-icon fa fa-file" aria-hidden="true"></i>
            <p>Press Media Articles</p>
          </a>
        </li>
           <li class="nav-item"  *ngIf="userRole == 1">
          <a class="nav-link" routerLink="/admin/podcast">
            <i class="nav-icon fa fa-podcast"></i>
            <p>Podcast</p>
          </a>
        </li>  
        <li class="nav-item" *ngIf="userRole == 1">
          <a class="nav-link" routerLink="/admin/episode">
            <i class="nav-icon fa fa-television" aria-hidden="true"></i>
            <p>Episodes</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="userRole == 1">
          <a class="nav-link" routerLink="/admin/podcast-category">
            <i class="nav-icon fa fa-tasks"></i>
            <p>Podcast Categories</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="userRole == 1">
          <a class="nav-link" routerLink="/admin/user">
            <i class=" nav-icon fa fa-user" aria-hidden="true"></i>
            <p>Registered Users</p>
          </a>
        </li>

        <li class="nav-item" *ngIf="userRole == 1">
          <a class="nav-link" routerLink="/admin/category">
            <!-- <i class=" nav-icon fa fa-user" aria-hidden="true"></i> -->
            <i class="nav-icon fa fa-cubes"></i>
            <p>Categories</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="userRole == 1">
          <a class="nav-link" routerLink="/admin/user-account-list">
            <!-- <i class=" nav-icon fa fa-user" aria-hidden="true"></i> -->
            <i class="nav-icon fa fa-cubes"></i>
            <p>User Account Delete</p>
          </a>
        </li>
        <li class="nav-item dropdown dropdown-custom" id="notifications">
          <a class="nav-link" href="javascript:void(0)" >
            <i class="nav-icon fa fa-bar-chart"></i>
            <p>Push Notification</p>
          </a>
          <button class="btn btn-secondary dropdown-toggle" id="side-dropdown" type="button">
          </button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLink="/admin/list-of-node">Article</a></li>
            <li><a class="dropdown-item" routerLink="/admin/episode-list-of-node">Episode</a></li>
            <li><a class="dropdown-item" routerLink="/admin/list-of-node/sent-messages">Sent Messages</a></li>
            <li><a class="dropdown-item" routerLink="/admin/list-of-node/schedule">Schedule</a></li>
            <!-- <li><a class="dropdown-item" routerLink="/admin/one-signal-notification">By One Signal</a></li> -->
            <!-- <li><a class="dropdown-item" routerLink="/admin/one-signal-sent-messages">One Signal Sent Messages</a></li> -->
      
          </ul>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link" routerLink="/admin/list-of-node/sent-messages">
            <i class="nav-icon fa fa-envelope"></i>
            <p>Sent Messages</p>
          </a>
        </li> -->
        <li class="nav-item" *ngIf="userRole == 1">
          <a class="nav-link" routerLink="/admin/web-master">
            <!-- <i class=" nav-icon fa fa-user" aria-hidden="true"></i> -->
            <i class="nav-icon fa fa-users"></i>
            <p>Publishers</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="userRole == 1">
          <a class="nav-link" routerLink="/admin/black-history">
            <!-- <i class=" nav-icon fa fa-user" aria-hidden="true"></i> -->
            <i class="nav-icon fa fa-history"></i>
            <p>Black History</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="userRole == 1">
          <a class="nav-link" routerLink="/admin/banner-image">
            <!-- <i class=" nav-icon fa fa-user" aria-hidden="true"></i> -->
            <i class="nav-icon fa fa-picture-o"></i>
            <p>Banner Images</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="userRole == 1">
          <!-- <a class="" (click)="userlist()"></a> -->
          <a class="nav-link" routerLink="/admin/meta-pages">
          <!-- <a href="javascript:void(0)"  class="nav-link"> -->
            <!-- <i class="fa-regular fa-page"></i> -->
            <!-- <i class="fa-solid fa-page"></i> -->
            
            <i class="nav-icon fa fa-file-o" aria-hidden="true"></i>
            <p>Meta-Pages</p>
          </a>
        </li>
        <li class="nav-item" *ngIf="userRole == 1">
          <!-- <a class="" (click)="userlist()"></a> -->
          <a class="nav-link" routerLink="/admin/app-version">
            <i class="nav-icon fa fa-file-o" aria-hidden="true"></i>
            <p>App Version</p>
          </a>
        </li>
        <!-- <li class="nav-item" *ngIf="userRole == 1">
          <a class="nav-link" routerLink="/admin/page-setting">
            <i class="nav-icon fa fa-window-restore"></i>
            <p>Page Settings</p>
          </a>
        </li> -->
        <li class="nav-item dropdown dropdown-custom" id="settings" *ngIf="userRole == 1">
          <a class="nav-link" href="javascript:void(0)" >
            <i class="nav-icon fa fa-cog"></i>
            <p>Settings</p>
          </a>
          <button class="btn btn-secondary dropdown-toggle" id="side-dropdown" type="button">
          </button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLink="/admin/user-setting">Users</a></li>
            <li><a class="dropdown-item" routerLink="/admin/comment">Comments</a></li>
          </ul>
        </li>
        <!-- <li class="nav-header">MAIN NAVIGATION</li> -->
        <!-- <li class="nav-item">
          <a href="#" routerLink="/admin/dashboard" class="nav-link">
            <i class="nav-icon fa fa-users"></i>
            <p>Content</p>
          </a>
        </li> -->


        <!-- <li class="nav-header">QUICK LINKS</li> -->
        <!-- <li class="nav-item">
          <a href="#" routerLink="/users/profile" class="nav-link">
            <i class="nav-icon fa fa-circle-o text-info"></i>
            <p class="text">Profile</p>
          </a>
        </li> -->
        <li class="nav-item">
          <a href="javascript:void(0)" (click)="logout()" class="nav-link">
            <i class="nav-icon fa fa-circle-o text-danger"></i>
            <p class="text">Logout</p>
          </a>
        </li>
      </ul>
    </nav>

  </div>
</aside>

